<template>
  <div class="line-items-table-body-item body-item-total px-i">
    <div class="line-items-table-cell col-12 col-sm-14 semibold">
      TOTAL
    </div>
    <div class="line-items-table-cell col-12 col-sm-10 text-right semibold">
      {{ formatInvoiceCurrency(invoiceTotal) }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import Mixin from "./Mixin";

export default {
  mixins: [
    Mixin
  ],

  computed: {
    ...mapGetters("lineItemsTable", [
      "invoiceTotal"
    ])
  }
};
</script>
